var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49045 2.53975C6.49045 1.13709 7.62753 0 9.0302 0L18.9697 0C20.3724 0 21.5095 1.13709 21.5095 2.53975V5.81635H21.7917V8.3561H21.5095L21.5095 25.4602C21.5095 26.8629 20.3724 28 18.9697 28H9.0302C7.62753 28 6.49045 26.8629 6.49045 25.4602L6.49045 10.8959H6.20825L6.20825 8.6383H6.49045V7.79171H6.20825V5.81635H6.49045L6.49045 2.53975ZM7.9798 3.55879C7.9798 2.46783 8.8642 1.58343 9.95516 1.58343L18.0447 1.58343C19.1357 1.58343 20.0201 2.46783 20.0201 3.55879L20.0201 24.4412C20.0201 25.5322 19.1357 26.4166 18.0448 26.4166H9.95517C8.8642 26.4166 7.9798 25.5322 7.9798 24.4412L7.9798 3.55879Z",
    fill: "#D2D2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5095 9.21045V25.4602C21.5095 26.8628 20.3724 27.9999 18.9698 27.9999H9.03023C7.62757 27.9999 6.49048 26.8628 6.49048 25.4602L6.49048 14.7368L7.97983 14.3683L7.97983 24.4411C7.97983 25.5321 8.86424 26.4165 9.9552 26.4165H18.0448C19.1357 26.4165 20.0201 25.5321 20.0201 24.4411V9.57887L21.5095 9.21045Z",
    fill: "#D2D2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97974 3.55886C7.97974 2.4679 8.86414 1.5835 9.9551 1.5835L18.0447 1.5835C19.1356 1.5835 20.02 2.4679 20.02 3.55886L20.02 24.4413C20.02 25.5322 19.1356 26.4166 18.0447 26.4166H9.9551C8.86414 26.4166 7.97974 25.5322 7.97974 24.4413L7.97974 3.55886Z",
    fill: "#D2D2D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.02 9.5791V24.4414C20.02 25.5323 19.1356 26.4167 18.0447 26.4167H9.9551C8.86414 26.4167 7.97974 25.5323 7.97974 24.4414L7.97974 14.3686L20.02 9.5791Z",
    fill: "#F5F5FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ff88293a7fd5ef7bef1a568b32c6a85a.svg";
export { ForwardRef as ReactComponent };